import React from "react";
import { isAuthenticated } from "utils/common";

const FooterLayout = ({ children }) => {
  return (
    <div className="container-fluid px-0 px-lg-4">
      {isAuthenticated() ? (
        <div className="clearfix px-0">
          <div className="w-80 float-end">{children}</div>
        </div>
      ) : (
        <div className="mt-5 mt-lg-0">{children}</div>
      )}
    </div>
  );
};

export default FooterLayout;
